<div class="container">
  <div class="row">
    <div class="col-sm-5">
      <form>
        <div class="form-group">
          <label>{{ 'label.FullName' | translate }}</label>
          <input
            type="text"
            class="form-control is-invalid"
            [(ngModel)]="adminUser.fullName"
            name="fullName"
          />
          <hr-field-state-marker [field]="field?.fullName">
          </hr-field-state-marker>
        </div>

        <div class="form-group">
          <label
            >{{ 'label.Position' | translate }}
            <span class="text-info small">
              <i>({{ 'label.Optional' | translate }})</i>
            </span>
          </label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="adminUser.position"
            name="position"
          />
        </div>

        <div class="form-group">
          <label>{{ 'label.Email' | translate }}</label>
          <input
            type="email"
            class="form-control"
            [(ngModel)]="adminUser.email"
            name="email"
          />
          <hr-field-state-marker [field]="field?.email">
          </hr-field-state-marker>
        </div>

        <div class="form-group">
          <label
            >{{ 'label.MobileNumber' | translate }}
            <span class="text-info small">
              <i>({{ 'label.Optional' | translate }})</i>
            </span>
          </label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="adminUser.mobileNumber"
            name="mobileNumber"
          />
          <hr-field-state-marker [field]="field?.mobileNumber">
          </hr-field-state-marker>
        </div>

        <div
          class="form-group"
          style="display: inline-block; width: 55% !important; margin-right: 1%"
        >
          <label
            >{{ 'label.Phone' | translate }}
            <span class="text-info small">
              <i>({{ 'label.Optional' | translate }})</i>
            </span>
          </label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="adminUser.phoneNumber"
            name="phoneNumber"
          />
          <hr-field-state-marker [field]="field?.phoneNumber">
          </hr-field-state-marker>
        </div>

        <div
          class="form-group"
          style="display: inline-block; width: 44% !important"
        >
          <label
            >{{ 'label.Extension' | translate }}
            <span class="text-info small">
              <i>({{ 'label.Optional' | translate }})</i>
            </span>
          </label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="adminUser.phoneExtension"
            name="phoneExtension"
          />
          <hr-field-state-marker [field]="field?.phoneExtension">
          </hr-field-state-marker>
        </div>

        <div class="form-group">
          <label>{{ 'label.Username' | translate }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="adminUser.username"
            name="username"
          />
          <hr-field-state-marker [field]="field?.username">
          </hr-field-state-marker>
        </div>

        <div class="form-group">
          <label>{{ 'label.Password' | translate }}</label>
          <input
            type="password"
            class="form-control"
            [(ngModel)]="adminUser.password"
            name="password"
          />
          <hr-field-state-marker [field]="field?.password">
          </hr-field-state-marker>
        </div>
      </form>
    </div>
  </div>

  <label>
    <input
      type="checkbox"
      (click)="onCheckAll()"
      [(ngModel)]="checkAll"
    />check/uncheck all permissions
  </label>

  <div class="form-group form-inline" style="display: inline !important">
    <label style="margin-left: 2%">
      {{ 'label.Role' | translate }}:
      <select class="form-control" [(ngModel)]="adminUser.roleId">
        <option *ngFor="let role of customRoles" [ngValue]="role.role">
          {{ role.title }}
        </option>
      </select>
    </label>
  </div>

  <div class="permissions">
    <div class="permissions-item">
      <div *ngFor="let permission of permissions">
        <label class="feature-type-label">
          {{ 'label.FeatureType' | translate }}:
          {{ FeatureTypeEnum[permission.featureType] }}
        </label>
        <div *ngFor="let feature of permission.features">
          <label class="feature-name-label">
            <input [(ngModel)]="feature.isChecked" type="checkbox" />{{
              feature.name
            }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <button class="btn btn-success btn-custom" (click)="onSave()">
    {{ 'label.Save' | translate }}
  </button>
  <button class="btn btn-danger btn-custom" (click)="onCancel()">
    {{ 'label.Cancel' | translate }}
  </button>
</div>
